import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, renderList as _renderList, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "main",
  id: "egcf-main"
}
const _hoisted_2 = { class: "filter-search-position-container" }
const _hoisted_3 = { class: "filter-button-search-wrapper" }
const _hoisted_4 = { class: "search-input-container" }
const _hoisted_5 = ["placeholder"]
const _hoisted_6 = { class: "button-container" }
const _hoisted_7 = { class: "active-filter-count-bubble" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-star" }, null, -1)
const _hoisted_9 = {
  key: 0,
  class: "filter-container"
}
const _hoisted_10 = { class: "filter" }
const _hoisted_11 = { class: "select" }
const _hoisted_12 = ["onUpdate:modelValue"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("option", null, null, -1)
const _hoisted_14 = ["value"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "select-bar" }, null, -1)
const _hoisted_16 = { class: "select-label" }
const _hoisted_17 = { class: "letter-filter-position-container" }
const _hoisted_18 = { class: "letter-filter-wrapper" }
const _hoisted_19 = { class: "letter" }
const _hoisted_20 = { class: "letter" }
const _hoisted_21 = { class: "letter" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = {
  class: "exhibitor-list",
  ref: "exhibitorList"
}
const _hoisted_24 = { class: "category" }
const _hoisted_25 = { class: "category-header" }
const _hoisted_26 = ["onClick", "id"]
const _hoisted_27 = { class: "exhibitor-content" }
const _hoisted_28 = ["src"]
const _hoisted_29 = { key: 1 }
const _hoisted_30 = { class: "exhibitor-infos" }
const _hoisted_31 = { class: "exhibitor-name" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = {
  key: 0,
  class: "exhibitor-location"
}
const _hoisted_34 = ["innerHTML"]
const _hoisted_35 = {
  key: 2,
  class: "stand-container"
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-map-marker-alt" }, null, -1)
const _hoisted_37 = { class: "stands" }
const _hoisted_38 = ["onClick", "innerHTML"]
const _hoisted_39 = {
  key: 1,
  class: "empty-search-results"
}
const _hoisted_40 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "white",
  viewBox: "0 0 448 512"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M34.9 289.5l-22.2-22.2c-9.4-9.4-9.4-24.6 0-33.9L207 39c9.4-9.4 24.6-9.4 33.9 0l194.3 194.3c9.4 9.4 9.4 24.6 0 33.9L413 289.4c-9.5 9.5-25 9.3-34.3-.4L264 168.6V456c0 13.3-10.7 24-24 24h-32c-13.3 0-24-10.7-24-24V168.6L69.2 289.1c-9.3 9.8-24.8 10-34.3.4z" })
], -1)
const _hoisted_41 = [
  _hoisted_40
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading_spinner = _resolveComponent("loading-spinner")!
  const _component_stand_dialog = _resolveComponent("stand-dialog")!
  const _component_product_detail_dialog = _resolveComponent("product-detail-dialog")!
  const _component_exhibitor_detail_dialog = _resolveComponent("exhibitor-detail-dialog")!
  const _component_qr_code_dialog = _resolveComponent("qr-code-dialog")!
  const _component_lazy_load_container = _resolveComponent("lazy-load-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_loading_spinner, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.$haveMaps)
      ? (_openBlock(), _createBlock(_component_stand_dialog, {
          key: 1,
          "on-close": _ctx.onStandDialogClose,
          ref: "standDialog"
        }, null, 8, ["on-close"]))
      : _createCommentVNode("", true),
    (_ctx.productContainer)
      ? (_openBlock(), _createBlock(_component_product_detail_dialog, {
          key: 2,
          "open-stand-dialog": _ctx.openStandDialog,
          themes: _ctx.productContainer.themes,
          "on-close-dialog": _ctx.onProductDialogClose,
          ref: "productDetailDialog"
        }, null, 8, ["open-stand-dialog", "themes", "on-close-dialog"]))
      : _createCommentVNode("", true),
    (_ctx.exhibitorContainer)
      ? (_openBlock(), _createBlock(_component_exhibitor_detail_dialog, {
          key: 3,
          "open-stand-dialog": _ctx.openStandDialog,
          themes: _ctx.exhibitorContainer.themes,
          ref: "exhibitorDetailDialog",
          "open-product-dialog": _ctx.openProductDetailDialog
        }, null, 8, ["open-stand-dialog", "themes", "open-product-dialog"]))
      : _createCommentVNode("", true),
    _createVNode(_component_qr_code_dialog, { ref: "qrCodeDialog" }, null, 512),
    (!_ctx.isLoading)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _withDirectives(_createElementVNode("input", {
                  type: "search",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchValue) = $event)),
                  onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onSearchValueInput && _ctx.onSearchValueInput(...args))),
                  spellcheck: "false",
                  autocapitalize: "none",
                  placeholder: _ctx.$t('search-input-placeholder')
                }, null, 40, _hoisted_5), [
                  [_vModelText, _ctx.searchValue]
                ])
              ]),
              _createElementVNode("div", _hoisted_6, [
                (_ctx.exhibitorFilter.filterExists())
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (!_ctx.hasActiveFilter())
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "active-filter-button active-filter-button-deactivated",
                            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleFilter && _ctx.toggleFilter(...args)))
                          }, " FILTER "))
                        : (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: "active-filter-button active-filter-button-active",
                            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleFilter && _ctx.toggleFilter(...args)))
                          }, [
                            _createElementVNode("span", _hoisted_7, _toDisplayString(Object.entries(_ctx.activeFilters).length), 1),
                            _createTextVNode(" FILTER ")
                          ])),
                      (_ctx.hasFavorites())
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 2,
                            class: "active-filter-button export-qr-code-button",
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openQrCodeDialog($event)))
                          }, [
                            _createTextVNode(_toDisplayString(_ctx.$t('export_favorites')) + " ", 1),
                            _hoisted_8
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.isFilterActive)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.exhibitorFilter.filters.ROOT, (filter) => {
                      return (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _withDirectives(_createElementVNode("select", {
                            class: "select-text",
                            required: "",
                            "onUpdate:modelValue": ($event: any) => ((_ctx.activeFilters[filter.id]) = $event),
                            onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onFilterChanged && _ctx.onFilterChanged(...args)))
                          }, [
                            _hoisted_13,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.exhibitorFilter.filters[filter.id], (option) => {
                              return (_openBlock(), _createElementBlock("option", {
                                value: option.id
                              }, _toDisplayString(option.title), 9, _hoisted_14))
                            }), 256))
                          ], 40, _hoisted_12), [
                            [_vModelSelect, _ctx.activeFilters[filter.id]]
                          ]),
                          _hoisted_15,
                          _createElementVNode("label", _hoisted_16, _toDisplayString(filter.title), 1)
                        ])
                      ]))
                    }), 256))
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.activeLetterFilter === 'all' ? 'selected': ''),
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onLetterClicked('all')))
                }, _toDisplayString(_ctx.$t('all')), 3)
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.activeLetterFilter === 'favorites' ? 'selected': ''),
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onLetterClicked('favorites')))
                }, _toDisplayString(_ctx.$t('favorites')), 3)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.exhibitorContainer.startLetters, (letter) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _createElementVNode("div", {
                    class: _normalizeClass([{ 'selected': _ctx.activeLetterFilter === letter},{'disabled': !_ctx.exhibitorContainer.letterExistsInCurrentList(letter)}]),
                    onClick: ($event: any) => (_ctx.exhibitorContainer.letterExistsInCurrentList(letter) ? _ctx.onLetterClicked(letter): () => {})
                  }, _toDisplayString(letter), 11, _hoisted_22)
                ]))
              }), 256))
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            (_ctx.exhibitorContainer && _ctx.exhibitorContainer.hasEntries())
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.exhibitorContainer.getExhibitorsMap(_ctx.pageSize), (exhibitorList, index) => {
                  return (_openBlock(), _createElementBlock("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, _toDisplayString(index), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(exhibitorList, (exhibitor) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "exhibitor",
                        onClick: ($event: any) => (_ctx.openExhibitorDetailDialog(exhibitor,$event)),
                        id: exhibitor.vueId
                      }, [
                        _createElementVNode("div", _hoisted_27, [
                          _createElementVNode("div", {
                            class: _normalizeClass(exhibitor.logo ? 'exhibitor-logo' : 'exhibitor-logo-letter')
                          }, [
                            _createVNode(_component_lazy_load_container, {
                              ref_for: true,
                              ref: "lazyLoadingContainer"
                            }, {
                              default: _withCtx(() => [
                                (exhibitor.logo)
                                  ? (_openBlock(), _createElementBlock("img", {
                                      key: 0,
                                      src: exhibitor.getLogoUrl()
                                    }, null, 8, _hoisted_28))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(exhibitor.getFirstLetter()), 1))
                              ]),
                              _: 2
                            }, 1536)
                          ], 2),
                          _createElementVNode("div", _hoisted_30, [
                            _createElementVNode("span", _hoisted_31, [
                              _createTextVNode(_toDisplayString(exhibitor.name) + " ", 1),
                              _createElementVNode("i", {
                                class: _normalizeClass([_ctx.isFavorite(exhibitor) ? 'fas': 'far', "fa-star"]),
                                onClick: ($event: any) => (_ctx.toggleFavorite(exhibitor,$event))
                              }, null, 10, _hoisted_32)
                            ]),
                            (exhibitor.location)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(exhibitor.location), 1))
                              : _createCommentVNode("", true),
                            (exhibitor.info)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 1,
                                  class: "exhibitor-description",
                                  innerHTML: _ctx.truncateExhibitorInfo(exhibitor.info)
                                }, null, 8, _hoisted_34))
                              : _createCommentVNode("", true),
                            (exhibitor.stands)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                  _hoisted_36,
                                  _createElementVNode("div", _hoisted_37, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(exhibitor.stands, (stand, index) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        class: "stand",
                                        onClick: ($event: any) => (_ctx.$haveMaps ? _ctx.openStandDialog(stand,$event):_ctx.openExhibitorDetailDialog(exhibitor,$event)),
                                        innerHTML: (stand.getDisplayName() + (index !== exhibitor.stands.length -1 ? ',' : ''))
                                      }, null, 8, _hoisted_38))
                                    }), 256))
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ], 8, _hoisted_26))
                    }), 256))
                  ]))
                }), 256))
              : (_ctx.exhibitorContainer && !_ctx.exhibitorContainer.hasEntries())
                ? (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(_ctx.$t('empty-search-results')), 1))
                : _createCommentVNode("", true)
          ], 512),
          _createElementVNode("div", {
            ref: "scrollToTopButton",
            class: "scroll-to-top-button",
            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.scrollTop && _ctx.scrollTop(...args)))
          }, _hoisted_41, 512)
        ], 64))
      : _createCommentVNode("", true)
  ]))
}